const refreshTokenKey = "refreshToken";
//获取token
var getToken = function () {
    return localStorage.getItem("AUTH_TOKEN");
};
//定时刷新token
var intervalRefreshToken = function () {
    setInterval(function () {
        getTimeToken(refreshTokenKey, 1000 * 60 * 60 * 2);
    }, 1000 * 60 * 2);
};
//设置带时间的token
var setTimeToken = function (value) {
    var curTime = new Date().getTime();
    localStorage.setItem(
        refreshTokenKey,
        JSON.stringify({ data: value, time: curTime })
    );
};
//获取带时间的token，并传入时间差exp
var getTimeToken = function (key, exp) {
    var data = localStorage.getItem(key);
    var dataObj = JSON.parse(data);
    if (new Date().getTime() - dataObj.time > exp) {
        var refreshToken = dataObj.data;
        this.instance
            .get("/login/login", {
                params: { username: "admin", password: "admin" },
            })
            .then((res) => {
                var data = res.data;
                if (data.code == 1) {
                    setTimeToken("refreshToken");
                    Vue.prototype.$axios.defaults.headers.common["token"] =
                        data.data.token.token;
                    localStorage.setItem("AUTH_TOKEN", data.data.token.token);
                }
            });
        // $.ajax({
        //     type: 'GET',   //POST/PUT/DELETE/HEAD...
        //     url: globalTest+"refresh-t",
        //     beforeSend: function(request) {
        //         request.setRequestHeader("Refresh-t",refreshToken);
        //     },
        //     dataType: 'json',	//text/script/xml/json/jsonp
        //     success: function (data) {
        //         console.log(data);
        //         if(data.success==1){
        //             localStorage.setItem("serviceToken",data.token);
        //             Vue.prototype.$axios.defaults.headers.common['Authorization'] =data.token;
        //             setTimeToken(refreshToken);
        //         }
        //     },
        //     error: function(data){
        //         console.log("error: "+data);
        //     }//响应失败的回调
        // });
    }
};

var tableHeight = function () {
    let heights = 0;
    let heightlen = 0;
    let classnameExists = !!document.getElementsByClassName("el-pagination");
    heightlen = classnameExists ? 170 : 0;

    this.heights =
        window.innerHeight - this.$refs.multipleTable.$el.offsetTop - heightlen;
    window.onresize = () => {
        this.heights =
            window.innerHeight -
            this.$refs.multipleTable.$el.offsetTop -
            heightlen;
    };
};

// 导出文件
let exportFile = (fileData, fileName) => {
    let url = window.URL.createObjectURL(new Blob([fileData]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName || "--"); //指定下载后的文件名，防跳转
    document.body.appendChild(link);
    link.click();
};

// 时间格式化
let dateFormatting = (date, fmt) => {
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};

/**
 * 从 Content-Disposition 头中解析文件名
 * @param {string} header - Content-Disposition 头值
 * @returns {string|null} - 解析后的文件名或 null
 */
var parseFileName = (header) => {
    if (!header) return null;

    // 定义解析模式（按优先级排序）
    const patterns = [
        // 1. RFC 5987 标准格式：filename*=UTF-8''encoded-filename
        /filename\*=UTF-8''([^;]+)/i,
        // 2. 双引号包含的 URL 编码文件名
        /filename="([^"]+)"/i,
        // 3. 未加引号的 URL 编码文件名（不常见）
        /filename=([^;]+)/i,
    ];

    for (const pattern of patterns) {
        const match = header.match(pattern);
        if (match) {
            try {
                // 优先处理标准格式的 UTF-8 编码
                if (pattern === patterns[0])
                    return decodeURIComponent(match[1]);

                // 处理双引号中的转义字符并解码
                return decodeURIComponent(match[1].replace(/\\(.)/g, "$1"));
            } catch (e) {
                console.warn("解码失败，尝试原始值:", e);
                return match[1].replace(/\\(.)/g, "$1");
            }
        }
    }

    return null;
};

let utils = {
    getToken,
    intervalRefreshToken,
    setTimeToken,
    getTimeToken,
    tableHeight,
    exportFile,
    dateFormatting,
    parseFileName,
};

export default utils;
